<template>
    <stage :content="content"/>
</template>

<script>
// @ is an alias to /src
import stageContent from '@/data/home.js'
import stage from '@/components/stage.vue'

export default {
  name: 'Home',
  components: {
    stage
  },
  data () {
    return {
      content: stageContent
    }
  }
}
</script>
